import { z } from 'zod';
export const featureSetting = z.enum(['csv_export_max_rows', 'zendesk_help_url']);
export const featureSettingsApiResponseModel = z.array(z.object({ featureSetting, value: z.unknown() }));
export const featureSettingsMap = z.object({
    [featureSetting.Enum.csv_export_max_rows]: z.number(),
    [featureSetting.Enum.zendesk_help_url]: z.string(),
});
